import forgot from './forgot';
import login from './login';
import menu from './menu';
import register from './register';
import reset from './reset';

// account settings
export default {
  label: 'Account Settings',
  name: 'account',
  component: 'group',
  fields: [
    {
      name: 'heading',
      label: 'Heading',
      component: 'text',
      defaultValue: 'My account',
    },
    menu,
    forgot,
    login,
    register,
    reset,
  ],
};
